<template>
    <div class="history-menu bg-white grid grid-cols-4 items-start justify-center text-16 text-center text-a-gray-a4a4a4 pt-4 relative" data-cy="container_history_menu_main">
        <router-link to="/history">
            <div class="relative h-12" data-cy="btn_history_menu_coupon" @click="onTracking('reward')"
                :class="{'active text-a-blue-2140a6' :activeTab == 'history-coupon'}"
                v-html="lbl.history.menu.coupon">
            </div>
        </router-link>
        <router-link to="/getfriend">
            <div class="relative h-12" data-cy="btn_history_menu_getfriend"
                :class="{'active text-a-blue-2140a6' :activeTab == 'history-getfriend'}"
                v-html="lbl.history.menu.get_friend">
            </div>
        </router-link>
        <router-link to="/history/point">
            <div class="relative h-12" data-cy="btn_history_menu_point" @click="onTracking('point')"
                :class="{'active text-a-blue-2140a6' :activeTab == 'history-point'}"
                v-html="lbl.history.menu.history_point">
            </div>
        </router-link>
        <router-link to="/favourite">
            <div class="relative h-12" data-cy="btn_history_menu_favourite" @click="onTracking('favorite')"
                :class="{'active text-a-blue-2140a6' :activeTab == 'history-favourite'}"
                v-html="lbl.history.menu.favourite">
            </div>
        </router-link>
    </div>
</template>
<script>
import LocaleMixin from '@/mixin/LocaleMixin.js';

export default {
    name: 'HistoryMenu',
    mixins: [LocaleMixin],
    data: function(){
        return {
            activeTab: this.$route.name,
        }
    },
    created: function(){

    },
    methods: {
        onTracking: function(data){
            if(!data) return;

            let tracking_category = '';
            let tracking_action = '';

            switch (data){
                case 'reward':
                    tracking_category = 'history_my_reward';
                    tracking_action = 'click_my_reward';
                    break;
                case 'point':
                    tracking_category = 'history_point';
                    tracking_action = 'click_point';
                    break;
                case 'favorite':
                    tracking_category = 'history_favorite';
                    tracking_action = 'click_history_favorite';
                    break;
            }
            this.tracking.event(tracking_category, tracking_action, null, null);
        }
    }
}
</script>
<style lang="scss" scoped>
.history-menu{
    .active::before{
        content: '';
        position: absolute;
        // bottom: -12px;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: #2140a6;
        color: #2140a6;
        width: 100%;
        height: 2px;
        border-radius: 4px;
    }
}
</style>
